<template>
    <div>
        <div id="serial_header_wrapper">
            <div class="serial-header-col">
                <div id="serial_campaign_img">
                    <img :src="serialModel.campaignImgUrl" />
                </div>
            </div>
            <!-- <div id="serial_campaign_info" class="serial-header-col">
                <div id="serial_campaign">{{serialModel.campaignName}}</div>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'SerialHeader',
    props: {
        serialModel: Object
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
#serial_header_wrapper {
    //@extend %display-flex;
    padding: 10px;
    margin-bottom: 7px;

    .serial-header-col {
        width: 100%;
        //flex: 0 0 50%;
        margin: {
            top: auto;
            bottom: auto;
        }
    }

    #serial_campaign_img {
        @include baseRatioImg(66.67%);
        border-radius: 15px;
        box-shadow: $box-shadow;
        width: 50%;
        margin: auto;
    }

    #serial_campaign_info {
        padding: {
            left: 20px;
        }

        #serial_campaign {
            font-size: 1.45rem;
            font-weight: normal;
            line-height: 0.9;
        }
    }
}
</style>
